<script>
	import Preservation from '@/components/preservation';
	import ReadyUploadSource from '@/components/readyUploadSource';

	export default {
		components: {
			Preservation,
			ReadyUploadSource,
		},
		data() {
			const validatePrice = (rule, value, callback) => {
				if (value === '' || value === null || value === undefined) {
					callback(new Error(rule.message));
					return;
				}

				if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
					callback(new Error('金额最多保留两位小数'));
					return;
				}

				callback();
			};

			const validateImageList = (rule, value, callback) => {
				if (!Array.isArray(value) || !value.length) {
					callback(new Error('请至少添加一张轮播图'));
					return;
				}

				callback();
			};

			return {
				id: '',
				form: {
					goods_classify_id: '',
					goods_name: '',
					goods_subtitle: '',
					goods_picture: '',
					goods_images: [],
					is_putaway: 1,
					goods_price: '',
					price: '',
				},
				goodsClassifyValue: [],
				goodsImagesList: [],
				accessory_classify_list: [],
				rules: {
					goods_classify_id: [{
						required: true,
						message: '请选择配件分类',
						trigger: 'change',
					}, ],
					goods_name: [{
						required: true,
						message: '请输入配件标题',
						trigger: 'blur',
					}, ],
					goods_subtitle: [{
						required: true,
						message: '请输入配件描述',
						trigger: 'blur',
					}, ],
					goods_images: [{
						required: true,
						validator: validateImageList,
						trigger: 'change',
					}, ],
					is_putaway: [{
						required: true,
						message: '请选择上架状态',
						trigger: 'change',
					}, ],
					goods_price: [{
						required: true,
						validator: validatePrice,
						message: '请输入同行价',
						trigger: 'blur',
					}, ],
					price: [{
						required: true,
						validator: validatePrice,
						message: '请输入零售价',
						trigger: 'blur',
					}, ],
				},
			};
		},
		methods: {
			syncClassifyValue() {
				if (!this.form.goods_classify_id || !this.accessory_classify_list.length) {
					this.goodsClassifyValue = [];
					return;
				}

				for (let i = 0; i < this.accessory_classify_list.length; i++) {
					const firstItem = this.accessory_classify_list[i];
					const childList = firstItem._child || [];
					for (let y = 0; y < childList.length; y++) {
						if (String(childList[y].id) === String(this.form.goods_classify_id)) {
							this.goodsClassifyValue = [firstItem.id, childList[y].id];
							return;
						}
					}
				}
			},
			handleClassifyChange(value) {
				this.form.goods_classify_id = Array.isArray(value) && value.length ? value[value.length - 1] : '';
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.validateField('goods_classify_id');
				});
			},
			syncGoodsPicture() {
				this.form.goods_picture = this.form.goods_images[0] || '';
			},
			getGoodsImages(list) {
				this.goodsImagesList.push(...list);
				this.form.goods_images = this.goodsImagesList.map((item) => item.path || item);
				this.syncGoodsPicture();
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.validateField('goods_images');
				});
			},
			removeGoodsImage(index) {
				this.goodsImagesList.splice(index, 1);
				this.form.goods_images = this.goodsImagesList.map((item) => item.path || item);
				this.syncGoodsPicture();
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.validateField('goods_images');
				});
			},
			changeGoodsImageOrder(list) {
				this.goodsImagesList = list;
				this.form.goods_images = this.goodsImagesList.map((item) => item.path || item);
				this.syncGoodsPicture();
				this.$refs.form && this.$refs.form.validateField('goods_images');
			},
			getAccessoryInfo() {
				this.$axios.post(this.$api.sourceGoods.accessory_info, {
					id: this.id,
				}).then(res => {
					if (res.code == 0) {
						const result = res.result || {};
						const goodsImages = result.goods_image || result.goods_picture || [];
						const imageList = (Array.isArray(goodsImages) ? goodsImages : goodsImages ? [goodsImages] :
							[]).map(item => item.path || item).filter(item => item);

						this.form = {
							...this.form,
							...result,
							goods_classify_id: result.goods_classify_id || '',
							goods_images: imageList,
							goods_picture: imageList[0] || '',
						};
						this.goodsImagesList = imageList.map(item => ({
							path: item,
						}));
						this.syncClassifyValue();
					}
				})
			},
			handleSubmit() {
				this.$refs.form.validate((valid) => {
					if (!valid) {
						return;
					}

					const submitData = {
						...this.form,
						...(this.id ? {
							id: this.id
						} : {}),
						goods_picture: (this.form.goods_images[0] || '').trim(),
					};

					this.$axios.post(this.id ? this.$api.sourceGoods.accessory_edit : this.$api.sourceGoods
							.accessory_add, submitData)
						.then(res => {
							if (res.code == 0) {
								this.$message.success(this.id ? '编辑成功' : '添加成功');
								this.$router.push('/sourceGoods/accessory/list')
							}
						})
				});
			},
			handleReset() {
				this.$refs.form.resetFields();
				this.goodsClassifyValue = [];
				this.goodsImagesList = [];
				this.form.goods_images = [];
				this.form.goods_picture = '';
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.clearValidate();
				});
			},
			getAccessoryClassify() {
				this.$axios.post(this.$api.sourceGoods.accessory_classify, {
					page: 1,
					rows: 100,
				}).then(res => {
					if (res.code == 0) {
						this.accessory_classify_list = res.result.list || res.result || [];
						this.syncClassifyValue();
					}
				})
			}
		},
		created() {
			this.id = this.$route.params.id || '';
			this.getAccessoryClassify()
			if (this.id) {
				this.getAccessoryInfo();
			}
		}
	};
</script>

<template>
	<el-main>
		<div class="form-page">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px" class="accessory-form">
				<el-form-item label="配件分类" prop="goods_classify_id">
					<el-cascader v-model="goodsClassifyValue" class="input-400" :options="accessory_classify_list"
						:props="{ value: 'id', label: 'name', children: '_child', expandTrigger: 'hover' }"
						placeholder="请选择配件分类" @change="handleClassifyChange"></el-cascader>
				</el-form-item>

				<el-form-item label="配件标题" prop="goods_name">
					<el-input v-model="form.goods_name" class="input-400" placeholder="请输入配件标题"></el-input>
				</el-form-item>

				<el-form-item label="配件描述" prop="goods_subtitle">
					<el-input v-model="form.goods_subtitle" class="input-400" type="textarea" :rows="3"
						placeholder="请输入配件描述"></el-input>
				</el-form-item>

				<el-form-item label="配件图片" prop="goods_images">
					<ReadyUploadSource isMany :manyPath="goodsImagesList" :isManyMax="10" @getSource="getGoodsImages"
						@removeThis="removeGoodsImage" @changeOrder="changeGoodsImageOrder"></ReadyUploadSource>
				</el-form-item>

				<el-form-item label="上架状态" prop="is_putaway">
					<el-radio-group v-model="form.is_putaway">
						<el-radio :label="1">上架</el-radio>
						<el-radio :label="0">下架</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="同行价" prop="goods_price">
					<el-input v-model="form.goods_price" class="input-400" placeholder="请输入同行价">
						<template slot="append">元</template>
					</el-input>
				</el-form-item>

				<el-form-item label="零售价" prop="price">
					<el-input v-model="form.price" class="input-400" placeholder="请输入零售价">
						<template slot="append">元</template>
					</el-input>
				</el-form-item>
			</el-form>

			<Preservation text="提交" @preservation="handleSubmit">
				<el-button slot="return" @click="handleReset">重置</el-button>
			</Preservation>
		</div>
	</el-main>
</template>

<style lang="less" scoped>
	.el-main {
		position: relative;
		width: 100%;
		height: 100%;
		padding-bottom: 80px;
		box-sizing: border-box;
		background: #fff;
	}

	.accessory-form {
		width: 100%;
	}

	.input-400 {
		width: 400px;
	}

	.form-tip {
		margin: 8px 0 0;
		font-size: 12px;
		color: #909399;
	}
</style>